export default {
  enable: false,
  id: "",
};
